import React from "react";
import { Tag } from "antd";

const STATUS_COLOR = {
  PENDING: "orange",
  CONFIRMED: "green",
  CANCELLED: "red",
  ERROR: "red",
  REFUNDED: "purple",
};

export const StatusTag = ({ booking }) => {
  const cancellationState = booking?.cancellation?.state;

  if (cancellationState === "PENDING_PROVIDER") {
    return <Tag color="gold">Cancelling…</Tag>;
  }
  if (cancellationState === "FAILED") {
    return <Tag color="red">Cancel failed</Tag>;
  }

  return (
    <Tag color={STATUS_COLOR[booking?.status] ?? "default"}>
      {booking?.status ?? "UNKNOWN"}
    </Tag>
  );
};

export const PaymentTag = ({ booking }) => (
  <Tag color={booking?.payment_status === "PAID" ? "green" : "orange"}>
    {booking?.payment_status ?? "UNKNOWN"}
    {booking?.paymentMethod ? ` · ${booking.paymentMethod}` : ""}
  </Tag>
);

export const TicketStateTag = ({ ticketed, hasProviderRef }) => {
  if (ticketed) return <Tag color="blue">Ticketed</Tag>;
  if (hasProviderRef) return <Tag color="cyan">Reserved</Tag>;
  return <Tag>Not issued</Tag>;
};
